import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ConfiguredLowerSidebar = () => {
  const [configuredItems, setConfiguredItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const API = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchConfiguredItems();
  }, []);

  const fetchConfiguredItems = async () => {
    try {
      // Try to fetch config without auth first, then with auth if needed
      let response;
      try {
        response = await axios.get(`${API}/api/admin/lower-sidebar-config`);
      } catch (error) {
        if (error.response?.status === 401) {
          // If auth required, skip showing anything for public users
          setConfiguredItems([]);
          return;
        }
        throw error;
      }
      
      setConfiguredItems(response.data.config || []);
    } catch (error) {
      console.error('Error fetching lower sidebar config:', error);
      setConfiguredItems([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-2xl shadow-lg p-4">
        <div className="animate-pulse space-y-3">
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-20 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  if (configuredItems.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-lg p-4">
        <p className="text-gray-500 text-center">No products configured for lower sidebar</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-lg p-4">
      <div className="grid grid-cols-1 gap-4">
        {configuredItems.map((item) => (
          <div
            key={`${item.source}-${item.id}`}
            className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-all duration-200"
          >
            {/* Product Image */}
            {item.image_url && (
              <div className="aspect-[4/3] overflow-hidden cursor-pointer">
                <img
                  src={item.image_url}
                  alt={item.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  onClick={() => window.open(item.store_url, '_blank')}
                />
              </div>
            )}

            {/* Product Info */}
            <div className="p-3">
              <h3 className="font-semibold text-gray-800 mb-2 line-clamp-2 text-sm">
                {item.title}
              </h3>
              
              <div className="font-bold text-green-600 mb-2 text-lg">
                ${item.price}
              </div>

              <button 
                onClick={() => window.open(item.store_url, '_blank')}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors font-medium py-1.5 px-3 text-xs"
              >
                Shop
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConfiguredLowerSidebar;